import { Heading } from '@simplywallst/ui-core';
import {
  FeedContainer,
  RecentSectionUpdatesWrapper,
  ShadowBlur,
} from './styled';

import loadable from '@loadable/component';
import { MoreUpdates } from '@/pages/CompanyReport/components/Overview/components/RecentUpdates/components/MoreUpdates';
import type { EventCategory } from '@/constants/events';
import { slugify } from '@utilities/slugify';
import { useTranslation } from '@/hooks/useTranslation';

const CompanyFeed = loadable(() => import('@/components/CompanyFeed'), {
  resolveComponent: (component) => component.CompanyFeed,
});

interface RecentSectionUpdatesProps {
  title?: string;
  lookup: string;
  filterByEventCategory?: EventCategory;
}
const RecentSectionUpdates = ({
  title = 'Recent updates',
  lookup,
  filterByEventCategory,
}: RecentSectionUpdatesProps) => {
  const t = useTranslation();
  return (
    <RecentSectionUpdatesWrapper
      templateRows="auto 1fr auto"
      rowGap="4px"
      data-cy-id={`introduction-${slugify(title)}`}
    >
      <Heading as="h3" typography="small">
        {title}
      </Heading>
      <FeedContainer>
        <CompanyFeed
          lookup={lookup}
          showLimit={6}
          isCompanyReport
          filterByEventCategory={filterByEventCategory}
          hoverBackground={'spaceGray'}
        />
      </FeedContainer>
      <ShadowBlur />
      <MoreUpdates
        lookup={lookup}
        menuTitle={title}
        filterByEventCategory={filterByEventCategory}
        buttonTitle={t('page.companyReport.feed.showAll')}
      />
    </RecentSectionUpdatesWrapper>
  );
};

export default RecentSectionUpdates;
